import {
  Directive,
  EmbeddedViewRef,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@UntilDestroy()
@Directive({
  selector: '[portalDelayedIf]',
  standalone: false,
})
export class DelayedIfDirective implements OnChanges, OnDestroy, OnInit {
  @Input('portalDelayedIf')
  if: boolean = false;

  @Input('portalDelayedIfDelay')
  delay: number = 100;

  show$!: Subject<boolean>;

  private embeddedView: EmbeddedViewRef<any> | null = null;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainerRef: ViewContainerRef
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if ('if' in changes && changes.if.firstChange === false) {
      this.show$.next(changes.if.currentValue);
    }
  }

  ngOnDestroy(): void {
    this.show$.complete();
  }

  ngOnInit(): void {
    this.show$ = new Subject<boolean>();

    this.show$.pipe(debounceTime(this.delay), untilDestroyed(this)).subscribe((show) => {
      if (show) {
        this.embeddedView?.destroy();
        this.embeddedView = this.viewContainerRef.createEmbeddedView(this.templateRef);
      } else {
        this.embeddedView?.destroy();
        this.embeddedView = null;
      }
    });

    this.show$.next(this.if);
  }
}
